var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-sticky',[_c('div',{staticClass:"top"},[_c('router-link',{attrs:{"to":"/search"}},[_c('search',{attrs:{"msg":"搜索书籍/作者"}})],1),_c('van-icon',{staticClass:"loginclass",attrs:{"size":"6vw","name":"user-o"},on:{"click":_vm.goPersonal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }